<mat-card class="paypoint-item">
  <div class="paypoint-content">
    <div class="paypoint-header">
      <mat-icon class="paypoint-icon">credit_card</mat-icon>
      <div class="paypoint-meta">
        <code class="paypoint-id">{{ paypoint.paypoint_code | paypointCode }}</code>
        <span class="status-badge valid" *ngIf="paypoint.valid">
          <mat-icon>check_circle</mat-icon>
          Valid
        </span>
        <span class="status-badge active" *ngIf="paypoint.active_route">
          <mat-icon>router</mat-icon>
          Active Route
        </span>
      </div>
    </div>

    <div class="paypoint-details">
      <div class="detail-item">
        <mat-icon>account_balance</mat-icon>
        {{ paypoint.provider }}
      </div>
      <div class="detail-item">
        <mat-icon>vpn_key</mat-icon>
        {{
          paypoint.provider === 'orientalbank'
            ? paypoint.psp_config.store_id
            : paypoint.psp_config.api_key
        }}
      </div>
    </div>
  </div>

  <div class="action-buttons">
    <button mat-stroked-button class="test-button" (click)="test.emit(paypoint.paypoint_code)">
      <mat-icon>verified_user</mat-icon>
      Test
    </button>
    <button
      mat-stroked-button
      color="primary"
      class="edit-button"
      (click)="edit.emit(paypoint.paypoint_code)"
    >
      <mat-icon>edit</mat-icon>
      Edit
    </button>
    <button
      mat-stroked-button
      color="warn"
      class="delete-button"
      (click)="delete.emit(paypoint.paypoint_code)"
    >
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  </div>
</mat-card>
